/* tslint:disable */
/* eslint-disable */
/**
 * My App
 * This is an awesome app!
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorMessage,
  LoginCredentials,
  Todo,
  TodoInput,
  UpdateTodoParameters,
} from '../models/index';
import {
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    LoginCredentialsFromJSON,
    LoginCredentialsToJSON,
    TodoFromJSON,
    TodoToJSON,
    TodoInputFromJSON,
    TodoInputToJSON,
    UpdateTodoParametersFromJSON,
    UpdateTodoParametersToJSON,
} from '../models/index';

export interface DeleteRemovetodoRequest {
    id: string;
}

export interface GetFetchTodosRequest {
    userId: string;
}

export interface PatchUpdateTodoRequest {
    id: number;
    updateTodoParameters?: UpdateTodoParameters;
}

export interface PostAddtodoRequest {
    todoInput?: TodoInput;
}

export interface PostApiSessionRequest {
    loginCredentials?: LoginCredentials;
}

/**
 * DefaultApi - interface
 * 
 * @export
 * @interface DefaultApiInterface
 */
export interface DefaultApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    deleteApiSessionDelRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteApiSessionDel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    deleteRemoveallRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteRemoveall(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    deleteRemovetodoRaw(requestParameters: DeleteRemovetodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteRemovetodo(requestParameters: DeleteRemovetodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getApiSessionCurrentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    getApiSessionCurrentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    getFetchTodosRaw(requestParameters: GetFetchTodosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Todo>>>;

    /**
     */
    getFetchTodos(requestParameters: GetFetchTodosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Todo>>;

    /**
     * 
     * @param {number} id The field used to get user id
     * @param {UpdateTodoParameters} [updateTodoParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    patchUpdateTodoRaw(requestParameters: PatchUpdateTodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Todo>>;

    /**
     */
    patchUpdateTodo(requestParameters: PatchUpdateTodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Todo>;

    /**
     * 
     * @param {TodoInput} [todoInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postAddtodoRaw(requestParameters: PostAddtodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Todo>>;

    /**
     */
    postAddtodo(requestParameters: PostAddtodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Todo>;

    /**
     * 
     * @param {LoginCredentials} [loginCredentials] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApiInterface
     */
    postApiSessionRaw(requestParameters: PostApiSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Todo>>;

    /**
     */
    postApiSession(requestParameters: PostApiSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Todo>;

}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI implements DefaultApiInterface {

    /**
     */
    async deleteApiSessionDelRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/session`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteApiSessionDel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteApiSessionDelRaw(initOverrides);
    }

    /**
     */
    async deleteRemoveallRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/todos`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteRemoveall(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRemoveallRaw(initOverrides);
    }

    /**
     */
    async deleteRemovetodoRaw(requestParameters: DeleteRemovetodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteRemovetodo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/todos/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteRemovetodo(requestParameters: DeleteRemovetodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRemovetodoRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getApiSessionCurrentUserRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/session`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async getApiSessionCurrentUser(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getApiSessionCurrentUserRaw(initOverrides);
    }

    /**
     */
    async getFetchTodosRaw(requestParameters: GetFetchTodosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Todo>>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getFetchTodos().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/todos/userid/{user_id}`.replace(`{${"user_id"}}`, encodeURIComponent(String(requestParameters['userId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TodoFromJSON));
    }

    /**
     */
    async getFetchTodos(requestParameters: GetFetchTodosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Todo>> {
        const response = await this.getFetchTodosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async patchUpdateTodoRaw(requestParameters: PatchUpdateTodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Todo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling patchUpdateTodo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/todos/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTodoParametersToJSON(requestParameters['updateTodoParameters']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TodoFromJSON(jsonValue));
    }

    /**
     */
    async patchUpdateTodo(requestParameters: PatchUpdateTodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Todo> {
        const response = await this.patchUpdateTodoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async postAddtodoRaw(requestParameters: PostAddtodoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Todo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/todos`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TodoInputToJSON(requestParameters['todoInput']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TodoFromJSON(jsonValue));
    }

    /**
     */
    async postAddtodo(requestParameters: PostAddtodoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Todo> {
        const response = await this.postAddtodoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */ApiClient
    async postApiSessionRaw(requestParameters: PostApiSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Todo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginCredentialsToJSON(requestParameters['loginCredentials']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TodoFromJSON(jsonValue));
    }

    /**
     */
    async postApiSession(requestParameters: PostApiSessionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Todo> {
        const response = await this.postApiSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
